import React, { useEffect, useState } from "react"
import "./Sidebar.css"
import { Box, Typography } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import MuiCard from "@mui/material/Card"
import { styled } from "@mui/material/styles"
import classNames from "classnames"
import logo from "../../assets/images/final_logo.png"
import { side_menus } from "../../constants/SideMenus"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp"
import { Menu } from 'lucide-react';
import { ArrowLeftCircle } from "lucide-react"
import { ChevronLeft, ChevronRight } from "lucide-react"; 
import { useDispatch, useSelector } from "react-redux"
import { fetchUserProfile } from "../../redux/Slice/AuthSlice"
const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: 0,
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(0),
  gap: theme.spacing(2),
  margin: "auto",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "250px",
  },
  boxShadow: "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  ...theme.applyStyles("dark", {
    boxShadow: "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  }),
}))

const Sidebar = ({isCollapsed, setIsCollapsed,dynamicMenus}) => {
  const [selectmenu, setSelectmenu] = useState("")
  const [subnav, setSubnav] = useState("")
  const location = useLocation();

  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.auth);


  const filteredMenus = dynamicMenus ? [
    side_menus[0], 
    side_menus[1], 
    ...dynamicMenus, 
  ] : [...side_menus];

  const handleMenu = (val, route) => {
    setSelectmenu(val)
    if (subnav !== val && !route) {
      setSubnav(val)
    } else {
      setSubnav(null)
    }
  }

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed)
  }

  useEffect(() => {
    const val = location.pathname;
    for (let i = 0; i < side_menus.length; i++) {
      if (side_menus[i].submenus) {
        for (let j = 0; j < side_menus[i].submenus.length; j++) {
          if (val === side_menus[i].submenus[j].route) {
            setSubnav(side_menus[i].menuName)
            setSelectmenu(side_menus[i].submenus[j].name)
          }
        }
      } else if (val === side_menus[i].route) {
        setSelectmenu(side_menus[i].menuName)
      }
    }
  }, [location.pathname])


  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          bgcolor="#2FB354"
          height="50px"
          boxSizing="border-box"
          p="5px"
          alignItems="center"
        >
          {isCollapsed ? (
            <ChevronRight
              size={24}
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleSidebar}
            />
          ) : (
            <ChevronLeft
              size={24}
              style={{ cursor: "pointer", color: "white" }}
              onClick={toggleSidebar}
            />
          )}
          {!isCollapsed && (
            <img
              src={logo}
              alt="logo"
              width="100%"
              height="100%"
              style={{ objectFit: "contain" }}
            />
          )}
        </Box>
        <div style={{ flex: "1", overflow: "auto", height: "100vh", boxShadow: " 0 0 10px 0 rgba(0,0,0,0.1)", paddingTop: 5 }}>
          {filteredMenus.map((val, index) => (
            <React.Fragment key={index}>
              {(profile?.permissions?.map(fc => fc.moduleName))?.includes(val.menuName) || (profile?.permissions?.map(fc => fc.moduleName))?.includes("*") ? (val.route ? (
                <Link to={val.route} onClick={() => handleMenu(val.menuName, val.route)} style={{ textDecoration: "none", color: "inherit" }}>
                  <Box
                    className={classNames("sidemenu", `${selectmenu === val.menuName && "active"}`)}
                    style={{ borderRadius: "10px" }}
                    sx={{
                      py: 1,
                      pl: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: isCollapsed ? "center" : "flex-start",
                    }}
                    mx={1}
                    my={1}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                    {val.icon && <val.icon sx={{ marginRight: 1, color: "#297364" }} />}
                    {!isCollapsed && <Typography sx={{ marginLeft: 1 }}>{val.menuName}</Typography>}
                    </div>
                  </Box>
                </Link>
              ) : (
                <Box
                className={classNames("sidemenu", `${selectmenu === val.menuName && "active"}`)}
                sx={{
                  py: 1,
                  pl: isCollapsed ? 2 : 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isCollapsed ? "center" : "space-between", 
                  cursor: "pointer",
                  borderRadius: "10px",
                }}
                mx={1}
                onClick={() => handleMenu(val.menuName, val.route)}
              >
                <div style={{ display: "flex", alignItems: "center", flexGrow: 1 }}> 
                  {val.icon && <val.icon sx={{ marginRight: 2 }} style={{ color: "#297364" }} />}
                  {!isCollapsed && <Typography sx={{ marginLeft: 1 }}>{val.menuName}</Typography>}
                </div>
                {val.submenus && !isCollapsed && (
                  <div style={{ marginLeft: "auto" }}> 
                    {subnav === val.menuName ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </div>
                )}
              </Box>
              )) : null}
              {subnav === val.menuName && (
                <Box>
                  {val.submenus.map((submenu, subIndex) => (
                    <React.Fragment key={subIndex}>
                    {val?.actions?.filter((rf) => rf.mname === submenu?.name)?.map((rf) => rf.value)?.some((action) => profile?.permissions?.find((gh) => gh.moduleName === val.menuName)?.actions?.includes(action)) || 
                      (profile?.permissions?.find(gh => gh.moduleName === "*" || gh.moduleName ===  val.menuName))?.actions?.includes("*")
                      ?
                    <Link to={submenu.route} onClick={() => setSelectmenu(submenu.name)} style={{ textDecoration: "none", color: "inherit" }}>
                      {!isCollapsed && (
                        <Box
                          sx={{
                            py: 1,
                            pl:  2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: isCollapsed ? "center" : "flex-start",

                            "&:hover": {
                              "& .icon": {
                                padding: "6px", // Increased padding on hover
                              },
                              "& .submenuItem": {
                                fontWeight: "bold", // Typography bold on hover
                              },
                            },
                          }}
                          className={classNames("submenuItem", `${selectmenu === submenu.name && "active"}`)}
                        >
                          <Box
                            sx={{
                              padding: "3px",
                              borderRadius: "50%",
                              backgroundColor: "#2FB354",
                              transition: "padding 0.2s ease-in-out", // Smooth transition
                            }}
                            className={`icon ${selectmenu === submenu.name && "activeIcon"}`}
                            ml={2}
                            mr={1}
                          />
                          <Typography className={classNames("submenuItem", `${selectmenu === submenu.name && "active"}`)}>{submenu.name}</Typography>
                        </Box>
                      )}
                    </Link>
                      :
                      null
                    }
                    </React.Fragment>
                  ))}
                </Box>
              )}
            </React.Fragment>
          ))}
        </div>
      </Box>
    </div>
  )
}

export default Sidebar
